module.exports = __webpack_public_path__ + "img/arrow_up_blue.52d49b55.svg";